import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  SupplierListCreatePage,
  SupplierListEditPage,
  SupplierListPage,
} from '../lazyPages';

export const SupplierListRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.SUPPLIER_LIST')}>
            <SupplierListPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute
            pageName={t('SUPPLIER_LIST.CREATE_EDIT.CREATE_TITLE')}
            action="create"
          >
            <SupplierListCreatePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute
            pageName={t('SUPPLIER_LIST.CREATE_EDIT.EDIT_TITLE')}
            action="update"
          >
            <SupplierListEditPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
